import gql from 'graphql-tag';

export const TEAM_FRAGMENT = gql`
  fragment teamInfo on Team {
    id
    name
    isActive
  }
`;
